var exports = {
  "qT": "xcc377c0b--07b541--features",
  "kb": "xcc377c0b--07b541--left",
};

module.exports = exports;
